/**
 * Sprint P32 · Selected-block outline in local scene space.
 * Highlights the currently-selected block with a cyan wireframe box.
 */
import { worldToScene } from "@/lib/sceneCoords";


export function SelectedBlockOutline({ block, origin, verticalExaggeration, defaultSize }) {
  const [dx, dy, dz] = [
    Number(block.dx || defaultSize[0]),
    Number(block.dy || defaultSize[1]),
    Number(block.dz || defaultSize[2]) * verticalExaggeration,
  ];
  const p = worldToScene(block.x, block.y, block.z, origin, verticalExaggeration);
  return (
    <mesh position={p} scale={[dx, dz, dy]}>
      <boxGeometry args={[1, 1, 1]} />
      <meshBasicMaterial color="#22D3EE" wireframe transparent opacity={0.9} />
    </mesh>
  );
}
